import React from "react";
import SettingsChangelog from "./SettingsChangelog";

const ChevronRight = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"
       style={{ color: "var(--sl-text-tertiary, #535862)" }}>
    <path d="M4.167 2.333L7.5 5.667L4.167 9" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SettingsPageWrapper = ({ settingsPath, title, lastEditedAt, changelogVersions, children }) => (
  <div className="mt-3">
    <div className="mb-4 d-flex align-items-center justify-content-between flex-wrap" style={{ gap: "var(--spacing-md, 8px)" }}>
      <nav aria-label="breadcrumb">
        <div className="d-flex align-items-center" style={{ gap: "var(--spacing-xs, 4px)" }}>
          <a
            href={settingsPath}
            className="settings-breadcrumb-link"
          >
            Settings
          </a>
          <ChevronRight />
          <span className="settings-breadcrumb-current">
            {title}
          </span>
        </div>
      </nav>
      <SettingsChangelog lastEditedAt={lastEditedAt} changelogVersions={changelogVersions} />
    </div>
    {children}
  </div>
);

export default SettingsPageWrapper;
